import PropTypes from 'prop-types';
import { ObjectPropsPropType } from '../../../services/proptypes';
import { BLUR_ANIMATION, BLUR_IN_TRANSITION, BLUR_OUT_TRANSITION, HEIGHT_TRANSITION, ZOOM_TRANSITION, ZOOM_ANIMATION, ANIMATION_STATUS } from '../animation.constants';
export var Transition = PropTypes.oneOf([BLUR_IN_TRANSITION, BLUR_OUT_TRANSITION, HEIGHT_TRANSITION, ZOOM_TRANSITION]);
export var AnimationName = PropTypes.oneOf([BLUR_ANIMATION, ZOOM_ANIMATION]);
export var TransitionProps = PropTypes.shape({
  preAnimating: ObjectPropsPropType,
  animating: ObjectPropsPropType,
  noAnimation: ObjectPropsPropType,
  config: PropTypes.shape({})
});
export var Animation = PropTypes.shape({
  name: AnimationName.isRequired,
  duration: PropTypes.number,
  transitionProps: TransitionProps,
  targetSelector: PropTypes.string
});
export var AnimationStatusPropType = PropTypes.oneOf(Object.values(ANIMATION_STATUS));